import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export interface RouterState<T> {
  pathname: string;
  previousPathname?: string;
  data: T;
  isDirty: boolean;
}

export interface RouterStates {
  [key: string]: RouterState<any>;
}

var initialState: RouterStates = {};

function emptyRouterState(key: string, value?: string) {
  return {
    [key]: {
      pathname: value ?? "",
      previousPathname: value ?? "",
      data: null,
      isDirty: false,
    } as RouterState<any>,
  } as RouterStates;
}

export const localRouterSlice = createSlice({
  name: "localRouter",
  initialState,
  reducers: {
    resetLocalRouter: () => initialState,
    initializeRouter: (state, action) => {
      const { key, value } = action.payload;
      if (!state[key]) {
        return { ...state, ...emptyRouterState(key, value) };
      }
      return state;
    },
    setPathname: (state, action) => {
      const { key, pathname } = action.payload;

      if (!state[key]) {
        state[key] = {
          pathname: pathname,
          previousPathname: pathname,
          data: null,
          isDirty: false,
        };
      } else {
        state[key].previousPathname = state[key].pathname;
        state[key].pathname = pathname;
      }
      return state;
    },
    setData: (state, action) => {
      const { key, data } = action.payload;
      if (!state[key]) {
        state[key] = {
          pathname: "",
          previousPathname: "",
          data: data,
          isDirty: false,
        };
      } else {
        state[key].data = data;
      }
    },
    setIsDirty: (state, action) => {
      const { key, isDirty } = action.payload;

      if (!state[key]) {
        state[key] = {
          pathname: "",
          previousPathname: "",
          data: null,
          isDirty: isDirty,
        };
      } else {
        state[key].isDirty = isDirty;
      }
    },
    initailizeIsDirty: (state) => {
      for (const key in state) {
        if (state[key]) {
          state[key].isDirty = false;
        }
      }
    },
  },
});

export const {
  resetLocalRouter,
  initializeRouter,
  setPathname,
  setData,
  setIsDirty,
  initailizeIsDirty,
} = localRouterSlice.actions;

export const localRouter = (state: RootState) => state.localRouter;

export default localRouterSlice.reducer;
